import React from "react";

const labels = {
  on: {
    da: "Til",
    en: "On",
    de: "An",
  },
  off: {
    da: "Fra",
    en: "Off",
    de: "Aus",
  },
};

/*
 * This component displays a toggle for settings in the best spots sidebar (used for season and wind)
 */

const SettingsToggle = (props) => {
  return (
    <div
      className="settingsCard"
      onClick={props.onClick}
      style={props.enabled ? enabledStyle : disabledStyle}
    >
      <div className="card-body">
        <h5 className="toggleTextLeft">{props.text}</h5>
        <h4 className="toggleTextRight">
          {props.info
            ? props.info
            : props.enabled
            ? labels.on[props.language]
            : labels.off[props.language]}
        </h4>
      </div>
    </div>
  );
};

const enabledStyle = {
  background: "#0000004d",
  opacity: "1",
};

const disabledStyle = {
  background: "#C2C2C24d",
  opacity: "0.5",
};

export default SettingsToggle;
